import { render, staticRenderFns } from "./weChartPayConfig.vue?vue&type=template&id=4003b02f&scoped=true"
import script from "./weChartPayConfig.vue?vue&type=script&lang=js"
export * from "./weChartPayConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4003b02f",
  null
  
)

export default component.exports